import { CHANNEL_ICONS, CHANNEL_COLORS } from "@/lib/channelStyle";

/**
 * Coloured icon pill for a channel — used in the Channels settings table,
 * the Tickets list "Channel" column, and the New Ticket form dropdown.
 *
 * Falls back to slate + MessageSquare when no metadata is available so it
 * still renders cleanly for tickets that reference a deleted channel.
 */
export default function ChannelPill({ channel, name, size = "sm" }) {
  // Accept either a full channel object OR just a name string (for tickets).
  const ch = channel || { name: name || "—", icon: "MessageSquare", color: "slate" };
  const Icon = CHANNEL_ICONS[ch.icon] || CHANNEL_ICONS.MessageSquare;
  const c = CHANNEL_COLORS[ch.color] || CHANNEL_COLORS.slate;
  const sz = size === "lg"
    ? "px-2.5 py-1 text-sm"
    : "px-2 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${c.bg} ${c.text} ${c.border} ${sz}`}
      data-testid={`channel-pill-${ch.name}`}
      title={ch.name}
    >
      <Icon className="w-3 h-3 flex-shrink-0" />
      {ch.name}
    </span>
  );
}
